
import { Component, Vue, Watch } from "vue-property-decorator";
import { Toast, Dialog } from "vant";
import { PageService, UserService, WechatService, EmployerStorePopupService, GaodeService } from "src/services";
import tabbar from "src/components/tabbar";
import router from "src/router";

import BannerPage from "src/views/components/banner/page.vue";
import TitlePage from "src/views/components/title/page.vue";
import NavigationPage from "src/views/components/navigation/page.vue";
import ProductPage from "src/views/components/product/page.vue";
import InformationPage from "src/views/components/information/page.vue";
import Personal from "src/views/components/personal/page.vue";
import SearchPage from "src/views/components/search/page.vue";
import CityfilterPage from "src/views/components/cityfilter/page.vue";
import PrefecturePage from "src/views/components/prefecture/page.vue";
import OrderPage from "src/views/components/order/page.vue";
import ProductGroupPage from "src/views/components/productGroup/page.vue";
import RightsPage from "src/views/components/rights/page.vue";
import CouponPage from "src/views/components/coupon/page.vue";
import vueWaterfallEasy from "src/utils/vue-waterfall-easy/vueWaterfallEasy";

import { tools } from "src/utils";
import { create } from "domain";

Component.registerHooks(["beforeRouteLeave"]);

@Component({
  components: {
    tabbar,
    BannerPage,
    TitlePage,
    NavigationPage,
    ProductPage,
    PrefecturePage,
    OrderPage,
    InformationPage,
    Personal,
    SearchPage,
    CityfilterPage,
    ProductGroupPage,
    RightsPage,
    CouponPage,
    vueWaterfallEasy,
  },
})
export default class HealthProductHome extends Vue {
  /**
   * 菜单列表
   * @protected
   */
  private menuList: Array<any> = [
    {
      componentType: 1,
      name: "轮播图",
      pageComponent: "BannerPage",
    },
    {
      componentType: 2,
      name: "标题文本",
      pageComponent: "TitlePage",
    },
    {
      componentType: 3,
      name: "导航栏",
      pageComponent: "NavigationPage",
    },
    {
      componentType: 4,
      name: "产品",
      pageComponent: "ProductPage",
    },
    {
      componentType: 7,
      name: "店铺信息",
      pageComponent: "InformationPage",
    },
    {
      componentType: 8,
      name: "专区",
      pageComponent: "PrefecturePage",
    },
    {
      componentType: 9,
      name: "个人信息",
      pageComponent: "Personal",
    },
    {
      componentType: 10,
      name: "订单",
      pageComponent: "OrderPage",
    },
    {
      componentType: 11,
      name: "产品分组",
      pageComponent: "ProductGroupPage",
    },
    {
      componentType: 12,
      name: "商品搜索",
      pageComponent: "SearchPage",
    },
    {
      componentType: 13,
      name: "城市筛选",
      pageComponent: "CityfilterPage",
    },
    {
      componentType: 14,
      name: "权益产品",
      pageComponent: "RightsPage",
    },
    {
      componentType: 15,
      name: "优惠券",
      pageComponent: "CouponPage",
    },
  ];

  /**
   * 首页自定义数据
   * @private
   * @returns any
   */
  protected pageData: any = {
    properties: "",
    pageType: null,
    name: "",
    id: null,
    enable: false,
    employerId: null,
    components: [],
    bgColor: "#f7f7f7",
    hasWaterfall: false,
  };

  /**
   * 瀑布流数据
   */
  protected waterfallData: any = {};

  /**
   * 除瀑布流数据
   */
  protected otherData: any = {};

  /**
   * 页面样式
   * @private
   * @returns any
   */
  protected pageStyle: any = {};

  /**
   * 获取当前登入信息
   * @private
   * @returns void
   */
  private get userInfo(): any {
    let userInfoStorge = localStorage.getItem("userInfo");

    if (userInfoStorge) {
      return JSON.parse(userInfoStorge);
    }

    return {};
  }

  /**
   * 推广弹窗信息
   * @private
   * @returns any
   */
  private get storePopupObj(): any {
    return this.$store.state.storePopupObj || null;
  }

  /**
   * 推广弹窗是否已显示过
   * @private
   * @returns any
   */
  private get showedStorePopup(): any {
    let data = { home: false, personalCenter: false };
    if (localStorage.getItem("showedStorePopup")) {
      return JSON.parse(localStorage.getItem("showedStorePopup"));
    } else {
      localStorage.setItem("showedStorePopup", JSON.stringify(data));
      return data;
    }
  }

  /**
   * 推广弹窗弹出位置map
   * @private
   * @returns object
   */
  private popupPositionMap: any = {
    home: 0,
    personalCenter: 1,
  };

  /**
   * 当路由发生变化的时候操作。
   * @protected
   * @param {any} - to 当前路由实例。
   * @returns {void}
   */
  //   @Watch("$route", { deep: true, immediate: true })
  //   protected updateOpen(to: any): void {
  //     this.getPageData();
  //   }

  /**
   * 获取首页配置信息
   * @private
   * @returns void
   */
  private async getPageData(): Promise<void> {
    try {
      // 首页配置类型
      let homeType = 2;
      let { content: result } = await PageService.instance.getPage({ pageType: homeType });
      if (result.data) {
        this.pageData = result.data;
        let components = []; // 转译
        result.data.components.forEach((element) => {
          let json = {
            componentType: element.componentType,
            properties: element.properties,
            icon: "",
            name: "",
            pageComponent: "",
            configComponent: "",
          };
          let temObj = this.menuList.filter((res) => res.componentType == element.componentType)[0];
          json.icon = temObj.icon;
          json.name = temObj.name;
          json.pageComponent = temObj.pageComponent;
          json.configComponent = temObj.configComponent;
          components.push(json);
        });
        this.pageData.components = components;
        this.pageData.employerId = result.data.employerId;
        this.pageData.enable = result.data.enable;
        this.pageData.id = result.data.id;
        this.pageData.name = result.data.name;
        this.pageData.pageType = result.data.pageType;
        this.pageData.properties = result.data.properties;
        this.pageData.bgColor = result.data.properties.bgColor;

        this.pageData.hasWaterfall = result.data.components.filter((item) => item.componentType == 11).length > 0;
        if (this.pageData.hasWaterfall) {
          this.waterfallData = result.data.components.filter((item) => item.componentType == 11)[0];
        }
        this.otherData = result.data.components.filter((item) => item.componentType != 11);

        this.pageStyle = { "background-color": (result.data.properties && result.data.properties.bgColor) || "" };
        document.title = result.data.properties.navigateTitle || "健康产品";
      }
    } catch (err) {
      Toast(JSON.stringify(err));
    }
  }

  /**
   * 自定义组件获取的消息
   * @private
   * @returns void
   */
  private diyMsg(data): void {
    if (data.type == 404) {
      // 体检报告
      // this.checkPrivacyTerm();
      router.push({ name: "reportAppointmentList" });
    }
  }

  protected onWeatchMiniBack = () => {
    ((wx as any).miniProgram as any)?.navigateBack(); // 退回到小程序
  };

  /* 获取当前位置信息
   * @private
   * @returns void
   */
  private async getGeolocation(): Promise<void> {
    if (localStorage.getItem("location")) {
      return;
    }
    this.$store.dispatch("setLocation", null);
    if (tools.isWechat()) {
      // 如果是微信环境
      this.weixinLocation();
    } else {
      let data = await GaodeService.instance.getBaiduLocation();
      this.$store.dispatch("setLocation", data);
    }
  }

  /* 获取当前位置信息 -- 微信
   * @private
   * @returns void
   */
  private async weixinLocation(): Promise<void> {
    let currentUrl = location.href;
    let { content: result } = await WechatService.instance.getWechatJSSDK(currentUrl);
    let loca = await WechatService.instance.getWechatLocation(result); // 获取经纬度-腾讯
    let locat = await GaodeService.instance.getCity((loca as any).longitude, (loca as any).latitude); // 通过经纬度获取城市-高德
    this.$store.dispatch("setLocation", locat);
  }

  protected async created() {
    await this.getGeolocation();
    this.getPageData();
    if (await tools.isWeatchMini()) {
      if (this.$route.query.isCloseMiniWx) {
        // 监听浏览器返回动作
        window.addEventListener("popstate", this.onWeatchMiniBack, true);
      }
    }
  }

  protected async destroyed() {
    if (await tools.isWeatchMini()) {
      setTimeout(() => {
        window.removeEventListener("popstate", this.onWeatchMiniBack, true);
      }, 100);
    }
  }

  /**
   * 判断是否数微信环境
   * @private
   * @returns boolean
   */
  private isWechat(): boolean {
    let ua = navigator.userAgent.toLowerCase();

    if (ua.indexOf("micromessenger") > -1) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 跳转小程序封装
   * @protected
   * @returns void
   */
  private wx_launch(info): void {
    if (!this.isWechat()) {
      return;
    }
    var btn = document.getElementById(info.eleId); //获取元素
    if (!btn) {
      return;
    }
    let script = document.createElement("script"); // 创建script内容插槽 避免template标签冲突
    script.type = "text/wxtag-template"; // 使用script插槽 必须定义这个type
    script.text = info.content; // 自定义的html字符串内容
    let html = `<wx-open-launch-weapp style="width:100%; height:100%;display:block;" username="${info.appid}" path="${info.url}">${script.outerHTML}</wx-open-launch-weapp>`;
    btn.innerHTML = html; // html字符串赋值
    // 点击按钮 正常跳转触发
    btn.addEventListener("launch", function (e) {
      console.log("success");
    });
    // 点击跳转 抛出异常
    btn.addEventListener("error", function (e) {
      console.log("fail", e);
      alert(`跳转异常 - ${JSON.stringify(e)}`);
    });
  }

  /**
   * 初始化jssdk
   * @private
   * @returns Promise<any>
   */
  private async init(): Promise<any> {
    if (this.isWechat()) {
      let url = location.href;
      let { content: result } = await WechatService.instance.getWechatJSSDK(url);
      if (result.data) {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: result.data.appId, // 必填，公众号的唯一标识
          timestamp: result.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: result.data.nonceStr, // 必填，生成签名的随机串
          signature: result.data.signature, // 必填，签名
          jsApiList: ["openLocation"],
          openTagList: ["wx-open-launch-weapp"], // 必填，需要使用的JS接口列表
        });

        wx.ready(function () {});
      }
    }
  }

  /**
   * 跳转个人版，获取Token的Key
   * @private
   * @returns void
   */
  private async setPersonalBtn(reportContent): Promise<void> {
    try {
      let { content: result } = await UserService.instance.jump2Personal();

      if (result.data) {
        // 跳转小程序
        let reportParams = {
          appid: "gh_387fc8fa08dd",
          eleId: "report", // 元素id
          url: `/pages/health-records/index?k=${result.data.key}&uId=${this.userInfo.genUserId}&i=wx41259acafe15eaeb&u=/pages/report/decode?id=${this.$route.query.id}`, // 跳转小程序的页面路径
          content: reportContent, // 自定义的html内容
        };

        this.wx_launch(reportParams);

        // 取消预约按钮
        let cancelParams = {
          appid: "gh_387fc8fa08dd",
          eleId: "appointment", // 元素id
          url: `/pages/health-records/index?k=${result.data.key}&uId=${this.userInfo.genUserId}&i=wx41259acafe15eaeb&u=/pages/report/decode?id=${this.$route.query.id}`, // 跳转小程序的页面路径
          content: reportContent, // 自定义的html内容
        };

        this.wx_launch(cancelParams);

        // 取消预约按钮
        let cancelParam = {
          appid: "gh_387fc8fa08dd",
          eleId: "cancelation", // 元素id
          url: `/pages/health-records/index?k=${result.data.key}&uId=${this.userInfo.genUserId}&i=wx41259acafe15eaeb&u=/pages/report/decode?id=${this.$route.query.id}`, // 跳转小程序的页面路径
          content: reportContent, // 自定义的html内容
        };
        this.wx_launch(cancelParam);
      }
    } catch (err) {
      Toast(JSON.stringify(err));
    }
  }

  /**
   * 获取店铺首页推广弹窗服务
   * @private
   * @returns void
   */
  private async getStorePopup(): Promise<void> {
    try {
      let popupPosition = this.popupPositionMap.home;
      let { content: result } = await EmployerStorePopupService.instance.getStorePopup(popupPosition);
      if (result.data) {
        // 处理跳转链接
        if (result.data.jumpLink) {
          result.data.jumpLink = JSON.parse(result.data.jumpLink);
          // 获取选中数据id
          if (result.data.jumpLink.dataList && result.data.jumpLink.dataList.length) {
            result.data.jumpLink.ids = result.data.jumpLink.dataList.map((item) => item.id);
          }
        }
        this.$store.dispatch("setStorePopupObj", {
          ...this.storePopupObj,
          home: result.data,
        });
      } else {
        this.$store.dispatch("setStorePopupObj", {
          ...this.storePopupObj,
          home: null,
        });
        this.showedStorePopup &&
          localStorage.setItem(
            "showedStorePopup",
            JSON.stringify({
              ...this.showedStorePopup,
              home: false,
            })
          );
      }
    } catch (err) {
      Toast(JSON.stringify(err));
    }
  }
  /**
   * dom加载完
   * @protected
   * @returns void
   */
  protected mounted() {
    this.init();
    let reportContent = `
            <button class="test-btn"></button>
            <style>
                .test-btn{
                    width: 100%;
                    height: 69px;
                    background: transparent;
                    border: none;
                    color:rgba(255,255,255,0)
                }
                .test-btn:focus{outline: 0}
            </style>
            `;
    if (localStorage.getItem("userInfo")) {
      this.getStorePopup();
      this.setPersonalBtn(reportContent);
    }
  }

  protected activated() {
    this.$nextTick(() => {
      let vueWaterfallEasyScrollDom: any = document.querySelector(".vue-waterfall-easy-scroll");
      if (vueWaterfallEasyScrollDom) {
        vueWaterfallEasyScrollDom.scrollTop = localStorage.getItem("domST") || 0;
      }
    });
  }

  /**
   * 组件离开之后
   * @private
   * @returns void
   */
  private beforeRouteLeave(to, from, next): void {
    let vueWaterfallEasyScrollDom: any = document.querySelector(".vue-waterfall-easy-scroll");
    if (vueWaterfallEasyScrollDom) {
      localStorage.setItem("domST", vueWaterfallEasyScrollDom.scrollTop);
    }
    next();
  }
}
